module.exports = __webpack_public_path__ + "img/wide.29acfa99.jpg";